import React from "react";
import { LargeVolumePickupConfigEditor } from "../features/large-volume-pickup-config";
import { withRestaurantId } from "../shared/components/layout";

const LargeVolumePickupConfigEditorWithId = withRestaurantId(LargeVolumePickupConfigEditor);

const LargeVolumePickupConfigPage: React.FC = () => {
  return <LargeVolumePickupConfigEditorWithId />;
};

export default LargeVolumePickupConfigPage;
